export interface User {
  id: string;
  name: string;
  email: string;
  role: string;
}

export const authService = {
  login: async (email: string, password: string) => {
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:5000/api'}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        // Extract error message from response
        let errorMessage = 'Login failed';
        if (data) {
          if (typeof data.message === 'string') {
            errorMessage = data.message;
          } else if (data.message?.message) {
            errorMessage = data.message.message;
          } else if (data.error) {
            errorMessage = typeof data.error === 'string' ? data.error : data.error.message || errorMessage;
          }
        }
        
        // Return error response
        return {
          success: false,
          message: errorMessage || `Login failed: ${response.statusText}`,
        };
      }
      
      if (data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
      }
      
      return data;
    } catch (error: any) {
      return {
        success: false,
        message: error.message || 'Network error. Please check your connection.',
      };
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: (): User | null => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('token');
  },

  isAdmin: (): boolean => {
    const user = authService.getCurrentUser();
    return user?.role === 'admin';
  },
};

